import website from '@/config/website';
import smCrypto from 'sm-crypto';

/**
 * sm2 加密方法
 * @param data
 * @returns {*}
 */
export function encrypt(data) {
  try {
    const msg = typeof data === 'string' ? data : JSON.stringify(data)
    // 防御：明文为空时加密仍会产生合法密文，后端解密得空串导致校验失败
    if (!msg && msg !== '0') {
      console.error('[sm2 encrypt] 明文为空，data:', data, 'dataType:', typeof data, 'msg:', msg)
    }
    return smCrypto.sm2.doEncrypt(msg, website.oauth2.publicKey, 0);
  } catch (e) {
    console.error('[sm2 encrypt] 加密抛异常:', e?.message || e, 'data:', data)
    return '';
  }
}
